<template>
  <div class="link-el">
    <img
      class="link__img"
      src="../../assets/icons/i_arrow-red.svg"
      alt="arrow"
    />
    <nuxt-link class="link__link" :to="link">{{ text }}</nuxt-link>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Link",
  props: {
    link: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.link {
  &-el {
    display: flex;
    align-items: center;
  }

  &__img {
    transform: rotate(180deg);
    margin-right: 1.5rem;
    height: 1rem;
  }

  &__link {
    color: $red;
    font-size: 1.4rem;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
